var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.4524C2 10.164 2 9.01981 2.5192 8.07127C3.0384 7.12274 3.98695 6.53404 5.88403 5.35666L7.88403 4.1154C9.88939 2.87082 10.8921 2.24854 12 2.24854C13.1079 2.24854 14.1106 2.87082 16.116 4.1154L18.116 5.35665C20.0131 6.53404 20.9616 7.12274 21.4808 8.07127C22 9.01981 22 10.164 22 12.4524V13.9735C22 17.8743 22 19.8248 20.8284 21.0366C19.6569 22.2485 17.7712 22.2485 14 22.2485H10C6.22876 22.2485 4.34315 22.2485 3.17157 21.0366C2 19.8248 2 17.8743 2 13.9735V12.4524Z",
    fill: "#0450DD",
    stroke: "#0450DD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.2485H9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.148a81fe47e7b9f347203323fb30e216.svg";
export { ForwardRef as ReactComponent };